import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function DialogEditAmenities({
  open,
  handleClose,
  data,
  handleOnChange,
  handleClickSubmit,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            marginTop: "1.2rem",
          }}
        >
          {"Edit Amenity"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <input
              style={{
                padding: "10px 15px",
                width: "15rem",
                height: "25px",
                background: "#FFFFFF",
                border: "1px solid #EBEBEB",
                borderRadius: "6px",
              }}
              value={data}
              onChange={handleOnChange}
              onInput={(e) => {
                e.target.value = e.target.value
                  .trimStart()
                  .replace(/[^a-zA-Z ]*/g, "");
              }}
            ></input>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            sx={{
              background: "#04AAD",
              marginRight: "1rem",
              width: "100.17px",
              height: "40px",
              marginBottom: "1.2rem",
              cursor: "pointer",
              fontSize: "12px",
            }}
            autoFocus
            disabled={!data}
            onClick={() => handleClickSubmit()}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
